// Home.js
import React, { useState } from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';
import Sidebar from '../components/Sidebar';
import TopGrantsTab from '../components/tabs/TopGrantsTab';
import MyPortfolioTab from '../components/tabs/MyPortfolioTab';
import ChatTab from '../components/tabs/ChatTab';
import UAResourcesTab from '../components/tabs/UAResourcesTab';
import AboutTab from '../components/tabs/AboutTab';

function Home({ currentTab, setCurrentTab }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [chatState, setChatState] = useState({
    messages: [],
    query: '',
    isQueryRunning: false
  });

  // Tab changes are now fully tracked in the Sidebar component
  
  const handleTabChange = (newTab) => {
    if (newTab === currentTab) return; // Prevent unnecessary tab switches
    
    setLoading(true);
    
    // Update tab state
    setTimeout(() => {
      setCurrentTab(newTab);
      setLoading(false);
    }, 300);
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 0:
        return <TopGrantsTab />;
      case 1:
        return <MyPortfolioTab />;
      case 2:
        return (
          <ChatTab 
            isSidebarOpen={isSidebarOpen}
            chatState={chatState}
            setChatState={setChatState}
          />
        );
      case 3:
        return <UAResourcesTab />;
      case 4:
        return <AboutTab />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
      <Sidebar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        currentTab={currentTab}
        onTabChange={handleTabChange}
      />

      <Box sx={{ flexGrow: 1, p: 2 }}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Fade in={!loading} timeout={300}>
            <Box>{renderTabContent()}</Box>
          </Fade>
        )}
      </Box>
    </Box>
  );
}

// Skip tracking for the home page since it's just a container for tabs
export default Home;
